"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var state = {
    DONE: 0,
    ERROR: 1,
    DOING: 2,
    TODO: 3
};
var Step = /** @class */ (function (_super) {
    __extends(Step, _super);
    function Step() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Step.prototype.render = function (props) {
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'm-step', {
            'vertical': props.vertical
        })), props.items.map(function (item, index) {
            return omi_1.h("div", { class: omi_1.classNames('_item', {
                    '_item-finish': item.state === state.DONE,
                    '_item-block': item.state === state.ERROR,
                    '_item-process': item.state === state.DOING,
                    '_item-wait': item.state === state.TODO,
                    'next-error': props.items[index + 1] && props.items[index + 1].state === state.ERROR
                }) },
                omi_1.h("div", { class: "_item-tail" }),
                omi_1.h("div", { class: "_item-icon" },
                    omi_1.h("span", { class: "icon" },
                        item.state === state.DONE && omi_1.h("i", { class: "anticon anticon-check finish-icon" },
                            omi_1.h("svg", { viewBox: "64 64 896 896", class: "", "data-icon": "check", width: "1em", height: "1em", fill: document.body.style.getPropertyValue('--mdc-theme-primary'), "aria-hidden": "true" },
                                omi_1.h("path", { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" }))),
                        item.state === state.ERROR && omi_1.h("i", { class: "anticon anticon-close error-icon" },
                            omi_1.h("svg", { viewBox: "64 64 896 896", class: "", "data-icon": "close", width: "1em", height: "1em", fill: document.body.style.getPropertyValue('--mdc-theme-error'), "aria-hidden": "true" },
                                omi_1.h("path", { d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" }))),
                        (item.state === state.DOING || item.state === state.TODO) && omi_1.h("span", { class: "icon" }, index + 1))),
                omi_1.h("div", { class: "_item-content" },
                    omi_1.h("div", { class: "_item-title" }, item.name),
                    omi_1.h("div", { class: "_item-description" }, item.description)));
        })));
    };
    Step.css = css;
    Step.propTypes = {
        items: Object,
        vertical: Boolean
    };
    Step = __decorate([
        omi_1.tag('m-step')
    ], Step);
    return Step;
}(omi_1.WeElement));
exports.default = state;
